export enum IncidentType {
  FailureToYield = "failure-to-yield",
  ParkedVehicleCollision = "parked-vehicle-collision",
  NoOtherVehicleInvolved = "no-otherVehicle-involved",
  RearEndCollision = "rear-end-collision",
  OncomingTrafficCollision = "oncoming-traffic-collision",
  SideSwipe = "side-swipe",
  LaneChangeIncident = "lane-change-incident",
  ParkingIncident = "parking-incident",
  NoContact = "no-contact",
  TippedOverEScooter = "tipped-over-e-scooter",
  Other = "other",
  PersonalDamagedItem = "personal-damaged-item",
  OtherPropertyDamage = "other-property-damage",
  AnimalInjury = "animal-injury",
  InjuredPerson = "injured-person",
  InjuryWhileAvoiding = "injury-while-avoiding",
}
